export enum EDemoEvent
{
    MinimizeDemo = 1,
    MaximizeDemo,
    ProxyPlotCommand,
    ResetDemo,
    EntitySelectionChanged,
}